module.exports = __webpack_public_path__ + "static/media/settings.35c8ded6.svg";